/**
 * Customer Map page.
 *
 * The map used to be an overlay behind a "Map" button on the Customers page.
 * It is now its own route under Admin Tools, which is where the rest of the
 * whole-business views live.
 *
 * This page exists to hold the customer profile a pin click opens. The map no
 * longer needs anywhere for a Back button to go — it renders inside the layout,
 * so the sidebar is right there.
 *
 * @module pages/CustomerMapPage
 */

import { useState } from 'react';
import { CustomerMap } from '../components/UserManagement/CustomerMap';
import { CustomerDetailsModal } from '../components/UserManagement/CustomerDetailsModal';

export const CustomerMapPage = () => {
  const [selectedCustomerId, setSelectedCustomerId] = useState<string | null>(null);

  return (
    <>
      <CustomerMap onCustomerClick={setSelectedCustomerId} />
      {selectedCustomerId && (
        <CustomerDetailsModal
          open
          customerId={selectedCustomerId}
          onClose={() => setSelectedCustomerId(null)}
        />
      )}
    </>
  );
};

export default CustomerMapPage;
